import React from 'react';

const TranslationContext = React.createContext({ t: (key) => key });

export default TranslationContext;